





















































































import Vue, { PropType } from "vue";

import moment from "moment";

import "vue-simple-suggest/dist/styles.css";
import VueJsonToCsv from "vue-json-to-csv";
import SelectBox from "@/components/util/SelectBox.vue";
import VariableInput from "@/components/util/VariableInput.vue";
import CorporateSideTabs from "@/parts/corporate/CorporateSideTabs.vue";
import { sortedByDateDesc } from "@/utils/momentUtils";

import { billingStatementResponse} from "@/api/dto/Corporation";
import { getCorporatebillingDeals } from "@/api/Corporation";

interface SaleDetail {
  dealId: string;
  title: string;
  updatedAt: string;
  projectName: string;
  amount: number;
  assessmentAmount: number;
}

interface Data {
  tab: string;
  tabs: { value: string; text: string }[];

  csvTitleSaleDetail: string;

  csvLabelsSaleDetail: {
        title : { title: '依頼内容' },
        requesterNickName : { title: '依頼者' },
        dealStartTime : { title: '開始日' }, 
        amount : { title: '金額' },
  },
  pageSaleDetail: number;
  showNum: number;
  periodFrom: string;
  periodTo: string;
  saleDetails: SaleDetail[];
  saleDetailData: billingStatementResponse[];
}

export default Vue.extend({
  name: "BillingStatement",
  components: {
    VueJsonToCsv,
    CorporateSideTabs,
    SelectBox,
    VariableInput,
  },
  data(): Data {
    this.$store.commit("setMode", { mode: "bill" });
    return {
      tab: "",
      tabs: [],
      csvTitleSaleDetail: 'billing_statement',
      periodFrom: '',
      periodTo: '',

      csvLabelsSaleDetail: {
        title : { title: '依頼内容' },
        requesterNickName : { title: '依頼者' },
        dealStartTime : { title: '開始日' }, 
        amount : { title: '金額' },
      },
      showNum: 20,
      saleDetailData: [],
      pageSaleDetail: 1,
      saleDetails: [] as SaleDetail[],
    };
  },

  async beforeRouteEnter(to, route, next) {
    try {
      const saleDetails = sortedByDateDesc(await getCorporatebillingDeals(), it => it.updatedAt);
      next((vm) => {(vm.$data as Data).saleDetails = saleDetails;});
    } catch (e) {
      next(false);
    }
  },
  mounted() {
    this.createTabs();
    this.tab = this.tabs[0].value;
  },
  computed: {
    mode(): string {
      return this.$store.state.mode;
    },
    currentPath(): string {
      return this.$route.path;
    },
    filteredSaleDetail(): billingStatementResponse[] {
      if(this.periodFrom && this.periodTo) {
        var start = moment(this.periodFrom);
        var end = moment(this.periodTo).endOf('days');
        return this.saleDetailData.filter(v => moment(v.updatedAt, 'YYYY/MM/DD HH:mm:ss').isBetween(start, end, null, '[]'));
      } else if(this.periodFrom) {
        var start = moment(this.periodFrom);
        return this.saleDetailData.filter(v => moment(v.updatedAt, 'YYYY/MM/DD HH:mm:ss').isSameOrAfter(start));
      } else if(this.periodTo) {
        var end = moment(this.periodTo).endOf('days');
        return this.saleDetailData.filter(v => moment(v.updatedAt, 'YYYY/MM/DD HH:mm:ss').isSameOrBefore(end));
      } else {
        return this.saleDetailData;
      }
    },
    startNumSaleDetail(): number {
      return Math.min(this.showNum * (this.pageSaleDetail - 1) + 1, this.filteredSaleDetail.length);
    },
    endNumSaleDetail(): number {
      return Math.min(this.showNum * this.pageSaleDetail, this.filteredSaleDetail.length);
    },
    showSaleDetail(): billingStatementResponse[] {
      return this.filteredSaleDetail.slice(this.startNumSaleDetail - 1, this.endNumSaleDetail);
    },

    // csvDataSaleDetail(): Array<{ [key: string]: string }> {
    //   if(this.dispTab.length) {
    //     return this.dispTab.map(item => {
    //       return {
    //         title: item.title,
    //         requesterNickName: item.requesterNickName,
    //         dealStartTime: moment(item.dealStartTime, 'YYYY/MM/DD HH:mm:ss').format('YYYY/M/D'),
    //         amount: this.$options.filters!.amountLocaleString(item.amount) + '円',
    //       }
    //     });
    //   } else {
    //     return [
    //       {
    //         title: '',
    //         requesterNickName: '',
    //         dealStartTime: '',
    //         amount: '',
    //       }
    //     ];
    //   }
    // },
    dispTab(): SaleDetail[] {
      return this.saleDetails.filter((v) => moment(v.updatedAt, "YYYYMM").format("YYYYMM").includes(this.tab));
    },
    dispTabSumAmount(): Number {
      let sumAmount = 0;
      this.dispTab.forEach((v) => {
        sumAmount += v.amount;
      });

      return sumAmount;
    },
  },
  methods: {
    changeTab(tab: string) {
      this.tab = tab;
    },
    detailLink(dealId: string) {
      return "/corporate/review/" + dealId;
    },
    formatDate(date: Date, fmt: string) {
      return moment(date).format(fmt);
    },
    getPaymentName(paymentType: string): string {
      if (paymentType == '1') {
        return "カード決済"
      } else if (paymentType == '2') {
        return "銀行振込"
      } else {
        return ""
      }
    },
    createTabs() {
      if (this.saleDetails.length == 0) {
        this.tabs.unshift({ value: "", text: "" });
        return;
      }
      var currentDate = moment(this.saleDetails[this.saleDetails.length - 1].updatedAt, "YYYYMM");

      while (currentDate < moment(this.saleDetails[0].updatedAt).add("y", 1)) {
        var date = moment(currentDate, "YYYYMM");
        if (this.saleDetails.some((u) => moment(u.updatedAt, "YYYYMM").format("YYYYMM") == date.format("YYYYMM"))) {
          this.tabs.unshift({ value: currentDate.format("YYYYMM"), text: date.format("YYYY年 M月") });
        }
        currentDate = date.add("M", 1);
      }
    },
  },
  filters: {
    amountLocaleString: function (amount: number) {
      return amount.toLocaleString();
    },
  },
});
